export const concatUrls = (basePath, appendix) => {
    const basePathWithoutExtension = basePath.endsWith('.html') ? basePath.replace('.html', '') : basePath;
    const normalizedBasePath = basePathWithoutExtension.endsWith('/')
        ? basePathWithoutExtension.slice(0, -1)
        : basePathWithoutExtension;
    const normalizedAppendix = appendix.startsWith('/') ? appendix.substring(1) : appendix;
    return `${normalizedBasePath}/${normalizedAppendix}`;
};
// RFC 3986 - compliant encoding
export const fixedEncodeURIComponent = (text) => {
    return encodeURIComponent(text).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
    });
};
export const getQueryStringParameter = (key) => {
    var _a;
    if (typeof window === 'undefined') {
        return;
    }
    const params = new URLSearchParams(window.location.search);
    return (_a = params.get(key)) !== null && _a !== void 0 ? _a : undefined;
};
export const removeURLParameter = (url, parameter) => {
    const [path, params] = url.split('?');
    if (params) {
        const urlParams = new URLSearchParams(params);
        urlParams.delete(parameter);
        const paramsRes = urlParams.toString();
        return paramsRes ? `${path}?${paramsRes}` : path;
    }
    return url;
};
